'use client';

import Box from '@mui/material/Box';

import { ErrorPageLayout } from './components/error-page-layout';

// ----------------------------------------------------------------------

/** `/error/404` · 전역 not-found — 페이지 없음 */
export function NotFoundView() {
  return (
    <ErrorPageLayout
      title="페이지를 찾을 수 없습니다."
      description={(
        <>
          링크가 잘못되었거나 페이지가 삭제되었습니다.
          <br /> 홈으로 이동해서 메뉴로 찾아주세요!
        </>
      )}
      illustration={<Box component='img' src='/assets/images/catchmoments/404.png' sx={{ my: 5, width: '60%', height: 'auto' }} />}
      actionLabel="홈으로 이동하기"
    />
  );
}
